var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.425.318a.875.875 0 0 1 0 1.237l-8.963 8.966a.873.873 0 0 1-.937.655.872.872 0 0 1-.937-.657L.575 6.505a.875.875 0 0 1 1.238-1.237l3.713 3.711L14.187.318a.875.875 0 0 1 1.238 0z"
  })));
};

export default SvgCheckmark;